module.exports = __webpack_public_path__ + "static/media/iv_freedomplanIntro.743ae616.svg";